const translations = {
    totalHoursOfFlight: 'Total Hours of Flight',
    totalNumberOfDrones: 'Total Number of Drones',
    totalNumberOfFlights: 'Total Number of Flights',
    totalNumberOfPilots: 'Total Number of Pilots'
};

export default translations;
